import type { TypeFormFieldElement } from '../../../types/form';

import { merge } from '../../../helper';

// ----------------------------------------------------------------------------

function getFields(form: HTMLFormElement, config: Record<string, any> = {}): TypeFormFieldElement[] {
    // Default Config
    const defConfig: Record<string, any> = {
        exclude: ['button', 'file', 'submit', 'reset'],
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const list: TypeFormFieldElement[] = [];
    //
    const elements = Array.from(form.elements) as TypeFormFieldElement[];

    // Foreach Elements
    for (const elField of elements) {
        //
        if (!elField.name || elField.disabled) {
            continue;
        }

        // --------------------------------------------------------------------

        // If using exclude
        if (config.exclude?.includes(elField.type)) {
            continue;
        }

        // --------------------------------------------------------------------

        // List Push
        list.push(elField);
    }

    //
    return list;
}

// ----------------------------------------------------------------------------

export default getFields;
